import React from "react";
import Tippy from "@tippyjs/react";
import {Icon} from "@/components/Icon.tsx";

interface TooltipProps {
  children?: React.ReactNode;
  noFill?: boolean;
}

const Tooltip = ({children, noFill} : TooltipProps) => {
  const icon = noFill ? 'fluent:question-circle-24-regular' : 'fluent:question-circle-24-filled';

  return (
      <Tippy
          content={
              <div className="p-2 normal-case">
                  {children}
              </div>
          }
          placement="right"
          theme = "dark"
          animation = "shift-away"
          arrow={true}
          interactive={true}
          maxWidth={400}
      >
          <div className="inline-block opacity-80">
              <Icon className="ml-2" icon={icon} width="20" />
          </div>
      </Tippy>
  );
};

export default Tooltip;
